import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from './AuthContext';
import ApiUrl from '../../utils/config';
import axios from 'axios';
import { RegisterModel, RoleClient } from '../../utils/apiClient';
import { DateLocal, DateType } from '../../common/components/DateLocal/DateLocal';
import PasswordRequirements from './PasswordRequirements';
import { validatePassword } from '../../utils/passwordPolicy';

const Register: React.FC = () => {
  const [formData, setFormData] = useState<RegisterModel>(new RegisterModel({
    lastName: '',
    firstName: '',
    patronymic: '',
    birthDate: new Date(),
    city: '',
    email: '',
    password: '',
    roleIds: [] as number[]
  }));
  const [confirmPassword, setConfirmPassword] = useState<string>('');
  const [roles, setRoles] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { register } = useAuth();
  const roleClient = new RoleClient(ApiUrl, axios);

  useEffect(() => {
    const fetchRoles = async () => {
      try {
        const response = await roleClient.getRoles();
        // Filter out admin role for public registration
        setRoles(response.filter(role => role.name !== 'Админ'));
      } catch (error) {
        console.error('Error fetching roles:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchRoles();
  }, []);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prevState) => new RegisterModel({
      ...prevState,
      [name]: value
    }));
  };

  // const handleDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   setFormData((prevState) => new RegisterModel({
  //     ...prevState,
  //     birthDate: new Date(e.target.value)
  //   }));
  // };

  const handleDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const timestamp = Date.parse(e.target.value);
    const [year, month, day] = e.target.value.split('-').map(Number);
    console.log(timestamp);
    if (Number.isNaN(timestamp) || year < 1900 || year > new Date().getFullYear()) {
      // setFormData((prevState) => new RegisterModel({
      //   ...prevState,
      //   birthDate: unde,
      // }));
    } else {
      const date = new Date(year, month - 1, day);
      setFormData((prevState) => new RegisterModel({
        ...prevState,
        birthDate: date,
      }));
    }
  };

  // console.log(formData.birthDate, formData.birthDate instanceof Date ? formData.birthDate.toStringForInput() : '');

  const handleRoleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const roleId = parseInt(e.target.value);
    const isChecked = e.target.checked;

    if (isChecked) {
      setFormData((prevState) => new RegisterModel({
        ...prevState,
        roleIds: [...formData.roleIds ?? [], roleId]
      }));
    } else {
      setFormData((prevState) => new RegisterModel({
        ...prevState,
        roleIds: formData.roleIds?.filter(id => id !== roleId)
      }));
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    // Validate password
    if (formData.password !== confirmPassword) {
      setError('Пароли не совпадают');
      return;
    }

    const passwordError = validatePassword(formData.password, formData.email);
    if (passwordError) {
      setError(passwordError);
      return;
    }

    try {
      await register(formData);
      navigate('/login');
    } catch (err: any) {
      setError(err.response?.data?.message || 'Ошибка регистрации. Попробуйте еще раз.');
    }
  };

  if (loading) {
    return <div>Загрузка...</div>;
  }

  return (
    <div className="register-page">
      <h2>Регистрация</h2>
      {error && <div className="error-message">{error}</div>}

      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Фамилия:</label>
          <input
            type="text"
            name="lastName"
            value={formData.lastName}
            onChange={handleInputChange}
            required
          />
        </div>

        <div className="form-group">
          <label>Имя:</label>
          <input
            type="text"
            name="firstName"
            value={formData.firstName}
            onChange={handleInputChange}
            required
          />
        </div>

        <div className="form-group">
          <label>Отчество (необязательно):</label>
          <input
            type="text"
            name="patronymic"
            value={formData.patronymic}
            onChange={handleInputChange}
          />
        </div>

        <div className="form-group">
          <label>Дата рождения:</label>
          {/* <input
            type="date"
            value={formData.birthDate.toISOString().split('T')[0]}
            onChange={handleDateChange}
            required
          /> */}
          <DateLocal
            onChange={(date) => date && setFormData((prevState) => new RegisterModel({
              ...prevState,
              birthDate: date,
            }))}
            type={DateType.date}
            value={formData.birthDate ?? new Date()}
            width={160}
          />
        </div>

        <div className="form-group">
          <label>Город:</label>
          <input
            type="text"
            name="city"
            value={formData.city}
            onChange={handleInputChange}
            required
          />
        </div>

        <div className="form-group">
          <label>Email:</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleInputChange}
            required
          />
        </div>

        <div className="form-group">
          <label>Пароль:</label>
          <input
            type="password"
            name="password"
            value={formData.password}
            onChange={handleInputChange}
            autoComplete="new-password"
            required
          />
          <PasswordRequirements password={formData.password} />
        </div>

        <div className="form-group">
          <label>Подтвердите пароль:</label>
          <input
            type="password"
            name="confirmPassword"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
          />
        </div>

        <div className="form-group">
          <label>Роли:</label>
          <div className="checkbox-group">
            {roles.map(role => (
              <div key={role.id} className="checkbox-item">
                <input
                  type="checkbox"
                  id={`role-${role.id}`}
                  value={role.id}
                  checked={formData.roleIds?.includes(role.id)}
                  onChange={handleRoleChange}
                />
                <label htmlFor={`role-${role.id}`}>{role.name}</label>
              </div>
            ))}
          </div>
        </div>

        <div className="form-actions">
          <button type="submit" className="btn">Зарегистрироваться</button>
          <Link to="/login">
            <button type="button" className="btn btn--back">У меня уже есть аккаунт</button>
          </Link>
        </div>
      </form>
    </div>
  );
};

export default Register;
